
import ActivityBlog from '@/components/ActivityBlog/ActivityBlog'
import PlaceCard from '@/components/PlaceCard'
import PlaceCardv2 from '@/components/PlaceCardv2'
import RentalCard from '@/components/RentalCard'
import SectionLoader from '@/components/SectionLoader'
import TrendingCard from '@/components/TrendingCard.vue';
import PackageTrendingCard from '@/components/PackageTrendingCard.vue';
import FilterCard from '@/components/FilterCard.vue';
import ShimmerEffect from "@/components/ShimmerEffect.vue";
import ActivityCard from "@/components/ActivityCard.vue";
export default {
  scrollToTop: true,
  layout: 'home',
  components: {
    ActivityBlog,
    PlaceCard,
    PlaceCardv2,
    RentalCard,
    SectionLoader,
    TrendingCard,
    PackageTrendingCard,
    FilterCard,
    ShimmerEffect,
    ActivityCard
  },
  head() {
    return {
      title: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.metaDesc()
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: this.metaKeywords()
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.metaDesc()
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: this.metaDesc()
      },
      {
        hid: 'image',
        property: 'image',
        content: this.metaImage()
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.metaImage()
      },
      {
        hid: 'og:image:secure_url',
        property: 'og:image:secure_url',
        content: this.metaImage()
      },
      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      stateSlug: null,
      currentImage: 0,
      interval: null,
      placeholderIndex: 0,
      placeholders: ['Beaches', 'Party Places', 'Best Sunset Places', 'Shacks', 'Yoga Places', 'Water sports', 'Churches', 'Casinos', 'Temples', 'Shopping', 'Adventure Places'],
      currentPlaceholder: '',
      // To store page section data populated from API
      title: "Goa waterfall - south goa waterfall | north goa waterfall",
      description: 'goa waterfall, south goa waterfall, north goa waterfall, surla goa waterfall, padi goa waterfall, goa waterfall near me, valpoi goa waterfall, goa waterfall dudhsagar, mumbai to goa waterfall',
      seoData: null,
      pageData: {
        thingsToDo: null,
      },
      allData: null,
      allActivitiesData: null,
      recentlyViewed: null,
      schemaData: [],
      urls: {
        bikeRental: null,
        carRental: null,
        waterSports: null,
        treks: null,
      },
      search: null,
      tabSelected: 0,
      hasPrev: false,
      hasNext: true,
      left: 0,
      originX: 0,
      originLeft: 0,
    };
  },
  jsonld() {
    return this.getJsonData()
  },

  async asyncData({ error, route, $axios }) {
    try {
      let data = await $axios.get('/api/states/app/getSEOContent/' + route.params.state)
    } catch {
      error({ statusCode: 404, message: 'Post not found' })
    }
    // if (route.params.state != 'goa')
    // error({ statusCode: 404, message: 'Post not found' })
  },

  async fetch() {
    this.seoData = await fetch(this.$config.fetchUrl + '/api/states/app/getSEOContent/' + this.$route.params.state)
      .then(res => res.json()).catch(error => {
        //this.$router.push({
//          path: '/'
//        })
        console.error("There was an error!", error); return false;
      });
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('locationClose'))
      document.getElementById('locationClose').click();
  },
  mounted() {

    this.getData()
    this.getActitvitesData()

    if (localStorage.getItem('placesFilter')) {
      localStorage.removeItem('placesFilter');
    }
    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    if (localStorage.getItem('blogsFilter')) {
      localStorage.removeItem('blogsFilter');
    }
    if (localStorage.getItem('ticketsFilter')) {
      localStorage.removeItem('ticketsFilter');
    }
    if (localStorage.getItem('reviewsFilter')) {
      localStorage.removeItem('reviewsFilter');
    }
    if (localStorage.getItem('searchFilter')) {
      localStorage.removeItem('searchFilter');
    }
    this.urls.bikeRental = this.$config.bikeRental;
    this.urls.carRental = this.$config.carRental;
    this.urls.waterSports = this.$config.waterSports;
    this.urls.treks = this.$config.treks;
  },

  methods: {

    metaDesc() {
      if (this.seoData && this.seoData.description) {
        return this.seoData.description
      } else {
        return this.description
      }
    },
    metaKeywords() {
      if (this.seoData && this.seoData.keywords) {
        return this.seoData.keywords;
      } else {
        return 'goa waterfall, south goa waterfall, north goa waterfall, surla goa waterfall, padi goa waterfall, goa waterfall near me, valpoi goa waterfall, goa waterfall dudhsagar, mumbai to goa waterfall'
      }
    },
    metaImage() {
      if (this.seoData && this.seoData.image) {
        return this.seoData.image;
      } else {
        return this.$config.siteUrl + '/img/meta-imgs/fallback.webp';
      }
    },

    //##Vue Scroll
    prev() {
      this.$refs.horizontal.prev()
    },
    next() {
      this.$refs.horizontal.next()
    },
    onScrollDebounce({
      hasPrev,
      hasNext
    }) {
      this.hasPrev = hasPrev
      this.hasNext = hasNext
    },
    onScroll({
      left
    }) {
      this.left = left
    },
    onMouseDown(e) {
      this.originX = e.pageX
      this.originLeft = this.left
      window.addEventListener("mouseup", this.onMouseUp);
      window.addEventListener("mousemove", this.onMouseMove);
    },
    onMouseUp() {
      window.removeEventListener("mouseup", this.onMouseUp);
      window.removeEventListener("mousemove", this.onMouseMove);
    },
    onMouseMove(e) {
      const offset = e.pageX - this.originX
      const left = this.originLeft - offset
      this.$refs.horizontal.scrollToLeft(left, 'auto')
    },
    // #End VueScroll
    async getData() {
      this.allData = await fetch(this.$config.fetchUrl + '/api/posts/app/getHomepageData').then(res => res
        .text());
      this.allData = this.getCryptKey(this.allData);
      this.$nextTick(() => {
        this.schemaData = this.allData && this.allData.featuredAttractions.length > 0 ? this.allData.featuredAttractions[0].posts : [];
      })
    },

    async getActitvitesData() {
      this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/posts/app/getHomepageActivities').then(res => res
        .text());
      this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
      this.changeThingsToDo(0)
    },

    changeThingsToDo(id) {
      switch (id) {
        case 0:
          this.pageData.thingsToDo = this.allActivitiesData.featuredActivities;
          break;
        case 1:
          this.pageData.thingsToDo = this.allActivitiesData.featuredActivities;
          break;
        case 2:
          this.pageData.thingsToDo = this.allActivitiesData.trendingPosts;
          break;
        case 4:
          this.pageData.thingsToDo = this.allActivitiesData.monsoonActivities;
          break;
        default:
          this.pageData.thingsToDo = this.allActivitiesData.featuredActivities;
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },
    //To display image of activities
    activitiesImage(image) {
      if (image && image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },
    checkTrendingCover(trending) {
      if (trending.post && trending.post.cover) {
        return trending.post.cover
      } else {
        if (trending.post && trending.post.gallery && trending.post.gallery.length > 0) {
          return trending.post.gallery[0]
        } else {
          return 'https://picsum.photos/600/600?random=1'
        }
      }
    },
    checkTrendingCategory(trending) {
      if (trending.post && trending.post.categories && trending.post.categories.length > 0) {
        return trending.post.categories[0].name
      }
      return null
    },
    getJsonData() {
      let structure = {
        "@context": "http://schema.org"
      }
      let data = this.schemaData.map((itm, index) => ({
        "@type": "LocalBusiness",
        "name": itm.title ? itm.title : 'Goa App',
        "image": itm.gallery ? itm.gallery : [],
        "address": {
          "@type": "PostalAddress",
          "streetAddress": itm.city ? itm.city.name : '',
          "addressLocality": "Goa",
          "postalCode": "403001",
          "addressCountry": "IN"
        },
        priceRange: '',
        "review": {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": itm.rating ? itm.rating.averageRating : '',
            "bestRating": itm.rating ? itm.rating.averageRating : '',
          },
          "author": {
            "@type": "Person",
            "name": "GoaApp"
          }
        },
      }))
      let sitesearch = {
        "@type": "WebSite",
        "@id": "https://goa.app/#website",
        "url": "https://goa.app/",
        "name" : "Goa App",
        "description" : "Goa Tourism Travel Guide",
        "alternateName" : "Goa.app",
        "inLanguage" : 'en-US'
      }
      data.push(sitesearch)
      let ds = {
        "@graph": data
      }
      return { ...structure, ...ds };
    },
    // STORE ATTRACTION PLACE RESULT IN LOCALSTORAGE
    storePlaceInLS(index, ind) {
      if (this.allData && this.allData.featuredAttractions) {
        let data = {
          postIndex: index,
          attractionIndex: ind,
          allAttractions: this.allData && this.allData.featuredAttractions ? this.allData.featuredAttractions : []
        }
        localStorage.setItem("plcData", JSON.stringify(data));
      }
    },
    removeAttaraction() {
      if (localStorage.getItem("plcData")) {
        localStorage.removeItem('plcData');
      }
    },
    scrollToActivities() {
      this.$nextTick(() => {
        this.scrollToJscustom('section-pop-1')
      })

    },
    scrollToJscustom(element) {
      var el = document.getElementById(element)
      const height = window.innerHeight;
      if (el) {
        if (window.innerWidth < 991) {
        } else {
          window.scroll({
            behavior: 'smooth',
            left: 0,
            top: height - 60
          });
        }

      }
    }
  },
}
